import getSummarySales from './getSummarySales';
import { distributePointByRatio } from 'utils';

export default function getCategorySalesData(
  or = [],
  d1 = [],
  d2 = [],
  d3 = []
) {
  const emptyName = '알 수 없음';

  const orderMap = new Map();

  or.forEach((order) => {
    const amounts = order.product_information.map(
      (item) => item.payment_price + Math.abs(item.discount_price)
    );
    const pointRatio = distributePointByRatio(
      amounts,
      Math.abs(order.use_point)
    );

    order.product_information.forEach((item, index) => {
      const { product_category_name, product_category } = item;

      let name = '';
      if (product_category_name) {
        name = product_category_name;
      } else if (product_category) {
        name = product_category.product_category_name ?? emptyName;
      } else {
        name = emptyName;
      }

      if (orderMap.has(name)) {
        orderMap.get(name).push({ ...item, point: pointRatio[index] });
      } else {
        orderMap.set(name, [{ ...item, point: pointRatio[index] }]);
      }
    });
  });

  const newList = [...d1, ...d2, ...d3];

  const categoryNames = [
    ...new Set(
      newList.map(
        (item) =>
          item.product?.product_category_name ??
          item.product?.product_category?.product_category_name ??
          emptyName
      )
    ),
  ];

  const categoryList = categoryNames.reduce((acc, cur) => {
    acc[cur] = newList.filter(
      (item) =>
        (item.product?.product_category_name ??
          item.product?.product_category?.product_category_name ??
          emptyName) === cur
    );
    return acc;
  }, {});

  const summaryData = getSummarySales(categoryList);

  const newSummaryData = summaryData.map((item) => {
    const items = orderMap.get(item.key) ?? [];

    const totalPoint = items.reduce((acc, cur) => {
      acc += cur.point ?? 0;
      return acc;
    }, 0);

    return {
      ...item,
      totalDiscount: item.totalDiscount + totalPoint,
      totalDeliveryDiscount: item.totalDeliveryDiscount + totalPoint,
      totalPickupDiscount: item.totalPickupDiscount + totalPoint,
      totalSubscriptionDiscount: item.totalSubscriptionDiscount + totalPoint,
      totalRentalDiscount: item.totalRentalDiscount + totalPoint,
    };
  });

  return newSummaryData;
}
